
import React from 'react';
import { Link } from 'react-router-dom';
import { Progress, Tooltip } from 'antd';

import arrow from "../../../../assets/svg/arrow-right.svg"


export default (props) =>{

    return (
        <div className="transfer-cost-report">
            <ul>
                <li>{props.direction}</li>
                <li>{props.source}</li>
                <li>{props.destination}</li>
                <li>{props.size}</li>
                <li>${props.cost}</li>
                <li>${props.totalCost}</li>
            </ul>
        </div>
    )
}

